import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Route, Router } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<ConfirmDialogComponent>, 
    @Inject(MAT_DIALOG_DATA) public data,
    private service: CommonService,
    private router: Router
    ) { 

    }

  ngOnInit(): void {
    console.log(this.data);
    
  }

  Cancel(){
    this.dialogRef.close()
  }

  doLogOut(){
    this.service.doLogout().subscribe(
      (res) => {
        console.log(res);
        sessionStorage.clear();
        this.dialogRef.close();
        this.router.navigate(['/logged-out'])
      },(err) => {
        console.log(err);
      }
    )
  }

}
